export const getFormChangedData = <T>(
  dirtyFields: { [key in keyof Partial<T>]: boolean | boolean[] },
  getFieldValue: (fieldName: string) => any
): Partial<T> => {
  const changedData: Partial<T> = {};

  Object.keys(dirtyFields).reduce((form, fieldKey) => {
    form[fieldKey as keyof T] = getFieldValue(fieldKey);
    return form;
  }, changedData);

  return changedData;
};
